import { SortOrder } from 'interfaces/general';
import { URLSearchParams } from 'url';

export const handleTableParams = (
  pagination: any,
  filters: any,
  sorter: any,
  searchParams: URLSearchParams,
  setSearchParams: (params: URLSearchParams) => void,
  isInvoiceTripParams: boolean = false,
) => {
  searchParams.set(isInvoiceTripParams ? 'tripPageNumber' : 'page', `${(pagination.current || 1) - 1}`);
  searchParams.set(isInvoiceTripParams ? 'tripPageSize' : 'size', pagination.pageSize || 10);
  searchParams.set('sortField', sorter.field ? sorter.field : '');
  searchParams.set('sortOrder', sorter.order ? sorter.order : '');

  for (let key in filters) {
    if (filters[key]) {
      searchParams.set(key, filters[key]);
    }
  }
  setSearchParams(searchParams);
};

export const handleTableParamsForPastInvoices = (
  pagination: any,
  filters: any,
  sorter: any,
  searchParams: URLSearchParams,
) => {
  // setting the new params with new instance.
  // after setting the new params will be set by component called this handler
  searchParams.set('page', `${(pagination.current || 1) - 1}`);
  searchParams.set('size', pagination.pageSize || 10);
  searchParams.set('sortField', sorter.field ? sorter.field : '');
  searchParams.set('sortOrder', sorter.order ? sorter.order : '');

  for (let key in filters) {
    if (filters[key]) {
      searchParams.set(key, filters[key]);
    }
  }
};

export const getSortingObject = (searchParams: { get: (arg0: string) => any }) => {
  const sort = {
    column: searchParams.get('sortField') || undefined,
    order: (() => {
      const sortOrder = searchParams.get('sortOrder');
      if (sortOrder) {
        return sortOrder === 'ascend' ? SortOrder.ASC : SortOrder.DESC;
      }
      return undefined;
    })(),
  };
  return Object.fromEntries(Object.entries(sort).filter(([_, v]) => v !== undefined));
};
